(function () {
  if (window.tstBoot) return;

  var TTL = 10 * 60 * 1000;
  var pending = {};

  function read(key) {
    try {
      var cached = JSON.parse(localStorage.getItem(key));
      if (cached && Date.now() - cached.time < TTL) return cached.value;
    } catch (e) {}
    return null;
  }

  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify({ time: Date.now(), value: value })); } catch (e) {}
  }

  function index(base) {
    if (pending[base]) return pending[base];

    var cached = read('tst-index:' + base);
    if (cached) {
      pending[base] = Promise.resolve(cached);
      return pending[base];
    }

    pending[base] = new Promise(function (resolve) {
      var items = [];
      var separator = base.indexOf('?') === -1 ? '?' : '&';
      function get(number, key) {
        return fetch(base + separator + (key || 'page') + '=' + number, { credentials: 'same-origin' })
          .then(function (response) { return response.text(); })
          .then(function (text) { try { return JSON.parse(text); } catch (e) { return null; } })
          .catch(function () { return null; });
      }
      get(1).then(function (first) {
        if (!first) { resolve(items); return; }
        items = items.concat(first.items || []);
        var key = 'page';
        if (first.next) {
          try {
            new URL(first.next, window.location.origin).searchParams.forEach(function (value, name) {
              if (name.indexOf('page') === 0) key = name;
            });
          } catch (e) {}
        }
        var rest = [];
        for (var number = 2; number <= (first.pages || 1); number++) rest.push(get(number, key));
        Promise.all(rest).then(function (pages) {
          pages.forEach(function (data) { if (data) items = items.concat(data.items || []); });
          if (items.length) write('tst-index:' + base, items);
          resolve(items);
        });
      });
    });
    return pending[base];
  }

  window.tstBoot = {
    start: index,
    index: index,
    getHtml: function () { return read('tst-html') || {}; },
    saveHtml: function (map) { write('tst-html', map); }
  };
})();
